class Api {
    static async multipart(route, params) {
        const url = `${route}`;

        const options = Object.assign({ method: "POST" });
        let token = JSON.parse(localStorage.getItem('token'))
        if (token != null) {
            // options.headers = {
            //     'Content-Type': 'multipart/form-data'
            // };
            var authKey = {
                'auth-key': `Token ${token}`
            }
            options.headers = authKey

        }
        const formData = new FormData();

        var input = Object.assign({}, params.input)

        if (input != null && input != undefined) {
            for (const key in input) {
                if (input[key] instanceof Object || input[key] instanceof Array) {
                    formData.append(key, JSON.stringify(input[key]));
                } else {
                    formData.append(key, input[key]);
                }
            }
        }

        if (params.files != null && params.files.length > 0) {
            for (let index = 0; index < params.files.length; index++) {
                const file = params.files[index];
                formData.append(file.name, file.value);
            }
        }

        options.body = formData;

        return fetch(url, options).then((resp) => {
            const json = resp.json();
            if (resp.ok) {
                return json;
            }
            return json.then((err) => {
                throw err;
            });
        });
    }
}
export default Api;
